<template>
  <div class="ibl-view-container">
    <div class="top-panel">
      <title-panel :count="resultsCount">{{ t('iblView.title') }}</title-panel>
      <vf-button
        v-if="canUserUpload"
        :size="ButtonSize.LARGE"
        :variant="ButtonVariant.SECONDARY"
        @click="handleUploadListClick()"
        >{{ t('iblView.uploadList') }}</vf-button
      >
      <ibl-upload-modal
        ref="modalRef"
        :project-id="projectId"
        :project-type="projectType"
        @ibl-import-finished="handleIblImportFinished"
      />
    </div>
    <vgbm-table-wrapper
      :key="vgbmTableWrapperRerenderKey"
      :project-id="projectId"
      @results-count-updated="handleResultsCountUpdated"
    />
  </div>
</template>

<script setup lang="ts">
  import { ref, computed } from 'vue';
  import { useRoles } from '@/composables/useRoles';
  import { ButtonVariant, ButtonSize } from '../VfButton/VfButton.types';
  import IblUploadModal from '../IblUploadModal/IblUploadModal.vue';
  import VgbmTableWrapper from '@/components/VgbmTableWrapper/VgbmTableWrapper.vue';
  import { ProjectType, Role } from 'types';
  import { useI18n } from 'vue-i18n';

  defineProps<{
    projectId: string;
    projectType: ProjectType;
  }>();

  const { t } = useI18n();

  const { isUserRole } = useRoles();

  const vgbmTableWrapperRerenderKey = ref(0);

  const canUserUpload = computed(() => {
    return isUserRole([
      Role.Admin,
      Role.DocuResponsible,
      Role.Coworker,
      Role.DigitalizationCoworker,
    ]);
  });

  const modalRef = ref<typeof IblUploadModal | null>(null);
  function handleUploadListClick() {
    modalRef.value?.show();
  }

  function handleIblImportFinished() {
    vgbmTableWrapperRerenderKey.value++;
  }

  const resultsCount = ref(0);
  function handleResultsCountUpdated(count: number) {
    resultsCount.value = count;
  }
</script>

<style lang="scss" scoped>
  .ibl-view-container {
    padding: 2rem 0;
    .top-panel {
      margin-bottom: 1.5rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
</style>
